// import { svg } from "config/svgStyles";

export const image = ({ backgroundImageUrl, isMobile }) => {
  return {
    width: isMobile ? "100%" : "100%",
    height: isMobile ? "100%" : "100%",
    margin: "0 0",
    backgroundImage: `url("${backgroundImageUrl}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    border: "10px",
    backgroundSize: "cover",
    flexGrow: "0",
    // padding: isMobile ? "150px 0" : "",
  };
};

export const contentContainer = ({ isDesktop, isTablet }) => ({
  width: isTablet ? "100%" : "100%",
  height: "100%",
  padding: "0px",
  display: "flex",
  flexDirection: isDesktop ? "row" : "column",
  zIndex: 100,
  flex: "100%",
});

export const graphic = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #CCCCCC",
  width: "100%",
  // boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.125)",
  borderRadius: "10px",
  height: "100%",
  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.375)",
};

export const imagesContainer = {
  display: "flex",
  width: "100%",
  height: "100%",
  overflow: "hidden",
  borderRadius: "10px 10px 0 0",
  backgroundSize: "cover",
};

export const graphicLabel = {
  display: "flex",
  padding: "20px",
  borderRadius: "0px 0px 10px 10px",
  backgroundColor: "white",
  width: "100%",
  justifyContent: "center",
};

export const gearSelectorContainer = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  gap: isMobile ? "15px" : "40px",
  justifyContent: "space-evenly",
  height: isMobile ? "550px" : "270px",
  width: isMobile ? "100%" : "100%",
  boxSizing: "border-box",
  // border: "2px solid red",
});

export const graphicContent = ({ isMobile }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "30px",
  justifyContent: "space-evenly",
  height: isMobile ? "600px" : "270px",
  width: isMobile ? "100%" : "100%",
  boxSizing: "border-box",
});

export const graphicTerms = ({ isMobile }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: isMobile ? "100%" : "100%",
  gap: "5px",
});
export const graphicTitle = ({ isMobile }) => ({
  color: "#fff",
  fontSize: isMobile ? "50px" : "70px",
  textAlign: "center",
  fontWeight: "500",
});
export const graphicText = ({ isMobile }) => ({
  color: "#fff",
  fontSize: isMobile ? "23px" : "25px",
  textAlign: "center",
  textTransform: "capitalize",
});
export const graphicDescription = ({ isMobile }) => ({
  color: "#fff",
  fontSize: isMobile ? "23px" : "20px",
  textAlign: "center",
  textTransform: "capitalize",
});
